export const DISTRIBUTION_TYPE = {
  PICKUP: 1,
  DELIVERY: 2,
  SHIPPING: 3,
}
